import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { currencyFormatter } from "@common/helpers/currency";
import { BankReconciliationRow } from "../bankReconciliationViewConfig";

export const BalanceCell = ({
    getValue,
}: CellContext<
    ViewTableFeatures,
    BankReconciliationRow,
    number | null | undefined
>) => {
    const value = getValue();
    if (typeof value !== "number") {
        return <ViewTableCell>-</ViewTableCell>;
    }
    return <ViewTableCell>{currencyFormatter.format(value)}</ViewTableCell>;
};
